import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  authApiClient,
  cxApiClient,
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const cxConsumerOnboardingApi = {
  getCategory: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/category_json",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        qs.push("config_level", "category");
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },
  getSubCategory: async (code_list: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/category_json",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        qs.push("config_level", "sub_category");
        qs.push("code_list", code_list);
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },
  getCity: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/territory_json",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        qs.push("config_level", "county");
        qs.push("show_inactive", true);
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  verifyEmail: async (email: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "verify/email",
      (qs) => {
        qs.push("email", email);
        qs.push("remote_utility_id", getRemoteUtilityId());
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getUtilityServices: async () => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "auth",
      "utility/services",
      (query) => {
        query.push("utility_id", getRemoteUtilityId());
      },
    );

    const response = await authApiClient.get(url);
    return response.data.result ?? [];
  },
  getConsumerRelation: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "choices/consumer_relation");
    const response = await cxApiClient.get(url);
    return response.data;
  },
  getOwnerType: async (): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "choices/ownership");
    const response = await cxApiClient.get(url);
    return response.data;
  },

  addConsumer: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "consumer");
    const response = await cxApiClient.post(url, payload);
    return response.data;
  },

  getConsumerDetail: async (consumer_id: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "consumer-detail",
      (qs) => {
        qs.push("consumer_id", consumer_id);
        qs.push("remote_utility_id", getRemoteUtilityId());
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },
  updateConsumer: async (consumerId: string, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `consumer/${consumerId}`);
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  verifyRejectDocuments: async (
    payload: any,
    documentId: any,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `consumer-document/${documentId}`);
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  //   surveyInProgress: async (consumerId: string,payload: any): Promise<any> => {
  //   const url = ApiEndpoints.createUrl("cx", `consumer_status/${consumerId}/SURVEY_INPROGRESS`);
  //   const response = await cxApiClient.put(url, payload);
  //   return response.data;
  // },

  getServiceOrder: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "search-service-order",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        qs.push("search_data", "");
        qs.push("association_type", "0");
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getCategoryFees: async (category: string): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "nsc-category-configuration",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        qs.push("category", category);
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  //https://api-cx-dev.bynry.com/api/cx/premise-detail/?premise=Oceania%231_Samoa%231_Upolu%231_Apia%231_Rural%20East%231_S01-DMA05%231_R06-DMA01-V-LEPA%231_R06-DMA01-V-SALEAPAGA%231_new%20premise%236&remote_utility_id=699

  getPremiseInfo: async (premise: string): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "premise-detail",
      (qs) => {
        qs.push("premise", premise);
        qs.push("remote_utility_id", getRemoteUtilityId());
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getUnitWiseConsumer: async (
    unitCode: string,
    remoteUtilityId: string | number,
    isCurrent: number = 1
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      "unit-wise/consumer",
      (qs) => {
        qs.push("unit_code", unitCode);
        qs.push("remote_utility_id", remoteUtilityId);
        qs.push("is_current", isCurrent.toString());
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getPremises: async (): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/territory_json",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        qs.push("config_level", "premise");
        qs.push("show_inactive", true);
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getPlans: async (consumerUtilityServices?: string[]): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "plan",
      (qs) => {
        qs.push("remote_utility_id", getRemoteUtilityId());
        if (consumerUtilityServices?.length) {
          consumerUtilityServices?.forEach((service) => {
            qs.push("utility_service", service);
          });
        }
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  surveyInProgress: async (consumerId: string, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "cx",
      `consumer_status/${consumerId}/SURVEY_INPROGRESS`,
    );
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  skipInspection: async (consumerId: string): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "cx",
      `consumer_status/${consumerId}/APPROVAL_INPROGRESS`,
    );
    const response = await cxApiClient.put(url);
    return response.data;
  },
  approveConsumer: async (consumerId: string, payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "cx",
      `consumer_status/${consumerId}/APPROVED`,
    );
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  acceptConsumer: async (consumerId: string): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `consumer/${consumerId}/Accepted`);
    const response = await cxApiClient.put(url);
    return response.data;
  },
  rejectConsumer: async (consumerId: string): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `consumer/${consumerId}/Reject`);
    const response = await cxApiClient.put(url);
    return response.data;
  },

  updateProgressStatus: async (
    consumerId: string,
    payload: any,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrl(
      "cx",
      `nsc-progress-status-change/${consumerId}`,
    );
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  getPlanDetails: async (
    remotePlanId: string | number,
    remoteUtilityId: string | number,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "plan",
      (qs) => {
        qs.push("remote_plan_id", remotePlanId);
        qs.push("remote_utility_id", remoteUtilityId);
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },
  addPlanPayment: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", "payment");
    const response = await cxApiClient.post(url, payload);
    return response.data;
  },
  getPlanParameters: async (
    planId: string | number,
    remoteUtilityId: string | number,
    utilityService: string[],
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "v1/plan/parameters",
      (qs) => {
        qs.push("plan_id", planId);
        qs.push("remote_utility_id", remoteUtilityId);
        if (utilityService?.length) {
          utilityService?.forEach((service) => {
            qs.push("utility_service", service);
          });
        }
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getRegistrationCharges: async (
    planId: string | number,
    remoteUtilityId: string | number,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "v1/plan/registration-charges",
      (qs) => {
        qs.push("plan_id", planId);
        qs.push("remote_utility_id", remoteUtilityId);
      },
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  getTerritoryJson: async (
    remoteUtilityId: string,
    configLevel: string,
    code_list: string,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/territory_json",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("config_level", configLevel);
        query.push("code_list", code_list);
      },
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  getTerritoryPremiseStats: async (
    remoteUtilityId: string,
    territoryCode: string,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "territory-premise-data",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        query.push("territory_code", territoryCode);
      },
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  updateAssignedServiceAddress: async (
    consumerId: string | number,
    payload: any,
  ): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "cx",
      `assigned-service-address/${consumerId}`,
    );
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  updateConsumerUnitPlan: async (
    consumerId: string | number,
    payload: { remote_plan_id: number; unit_code: string },
  ): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `update-plan/${consumerId}`);
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  updateConsumerStatus: async (
    consumerId: string | number,
    payload: { status: number },
  ): Promise<any> => {
    const url = ApiEndpoints.createUrl("cx", `consumer-status/${consumerId}`);
    const response = await cxApiClient.put(url, payload);
    return response.data;
  },

  getQuantityWiseResource: async (
    params: GetQuantityWiseResourceParams = {},
  ): Promise<any> => {
    return getQuantityWiseResource(params);
  },
};

export interface GetQuantityWiseResourceParams {
  remoteUtilityId?: string | number;
  consumerId?: string | number;
}

export const getQuantityWiseResource = async (
  params: GetQuantityWiseResourceParams = {},
): Promise<any> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "cx",
    "quantity-wise/resource",
    (qs) => {
      if (
        params.remoteUtilityId !== undefined &&
        params.remoteUtilityId !== null &&
        params.remoteUtilityId !== ""
      ) {
        qs.push("remote_utility_id", String(params.remoteUtilityId));
      }
      if (
        params.consumerId !== undefined &&
        params.consumerId !== null &&
        params.consumerId !== ""
      ) {
        qs.push("consumer_id", String(params.consumerId));
      }
    },
  );
  const response = await cxApiClient.get(url);
  return response.data;
};
